<template>
   <div>
  <section class="simple-nav">
      <div class="simplenav_wrap">
        <div class="simplenav_flex">
          <div class="nav-left-div">
            <a href="#" class="link-block w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/OhMyMeds_Logo_w.svg" alt="" src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" class="image-545"></a>
          </div>
        </div>
      </div>
      <div class="nav-shadow"></div>
    </section>
  <section class="form-section">
    <div class="login-box">
      <div class="enroll-slide-1" style="padding-top: 45px;">
        <div class="header-sub-div">
          <div class="enroll-header-2">Reset password</div>
          <p class="enroll-sub-2">Create a new secure password for your account</p>
        </div>
        <div class="form-block w-form">
          <form @submit.prevent="onSubmit">
            <div class="enroll-slide-1-div-3">
              <label for="password" class="label">New password</label>
              <input 
                class="text-field-59 email form update w-input" 
                maxlength="256" 
                name="password" 
                data-name="Password" 
                placeholder="Enter password" 
                type="password" 
                id="password" 
                required=""
                v-model="password"
              >
              <label for="repeat-password" class="label">Confirm password</label>
              <input 
                class="text-field-59 email form update w-input" 
                maxlength="256" 
                name="repeat-password" 
                data-name="Repeat Password" 
                placeholder="Repeat password" 
                type="password" 
                id="repeat-password" 
                required=""
                v-model="repeat_password"
              >
              
              <div class="w-form-fail" style="margin-bottom: 20px;" v-if="errorPassword">
                <div>Passwords do not match!</div>
              </div>
              
              <div class="enroll-form-button-div">
                <button 
                  type="submit"
                  class="enroll-form-submit-button w-button"
                  :disabled="submitted || errorPassword"
                >
                  <div v-if="submitted">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                      <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                      </circle>
                    </svg>
                  </div>
                  <div v-else>
                    Reset Password
                  </div>
                </button>
              </div>
              
              <div class="text-block-203">
                <router-link to="/login" class="link-17">Back to login <span class="text-span-182">-&gt;</span></router-link>
              </div>
            </div>
          </form>
          <div class="form-success" style="display:block; margin: 15px 30px;" v-if="success">
            <div>Password changed successfully. <router-link to="/login" class="success-link">Click here to login</router-link></div>
          </div>
          <div class="w-form-fail" style="display:block; margin: 15px 30px;" v-if="err">
            <div>Link expired or invalid!</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 220px;"></div>
  </section>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: ['baseUrl'],
  data() {
    return {
      password: '',
      repeat_password: '',
      submitted: false,
      success: false,
      err: false
    }
  },
  computed: {
    errorPassword() {
      if (this.password !== this.repeat_password && this.repeat_password !== '') {
        return true;
      }
      return false;
    }
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.err = false;
      this.$axios.post(this.baseUrl + '/api/password-reset', {
        password: this.password,
        token: this.$route.params.token
      }).then(response => {
        if (response.data.status == 'success') {
          this.success = true;
          this.submitted = false;
        } else {
          this.submitted = false;
          this.err = true;
        }
      });
    },
  }
}
</script>
